const DITypes = {
  SocketProcessingAdapter: Symbol('DmPortalSocketProcessingAdapter'),
  UploadDispatcherFactory: Symbol('DmPortalUploadDispatcherFactory'),
  UploadDispatcher: Symbol('DmPortalUploadDispatcher'),
  UploadAdapter: Symbol('DmPortalUploadAdapter'),
};

export default DITypes;
